import { gql } from '@apollo/client';

export const CREATE_JOB_STAKEHOLDER_MUTATION = gql`
  mutation createJobStakeholder(
    $jobId: Int!
    $role: String!
    $userId: Int!
  ) {
    createJobStakeholder(
      jobId: $jobId,
      role: $role,
      userId: $userId,
    ) {
      success
    }
  }
`;

export const DELETE_JOB_STAKEHOLDER_MUTATION = gql`
  mutation deleteJobStakeholder($id: Int!) {
    deleteJobStakeholder(id: $id) {
      status
    }
  }
`;

export const UPDATE_JOB_STAKEHOLDER_MUTATION = gql`
  mutation updateJobStakeholder(
    $id: Int!
    $role: String!
  ) {
    updateJobStakeholder(
      id: $id,
      role: $role,
    ) {
      jobStakeholder {
        id
      }
    }
  }
`;
